import { render } from "./SubClients.vue?vue&type=template&id=68a53b9c"
import script from "./SubClients.vue?vue&type=script&lang=js"
export * from "./SubClients.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__